const { createContext } = require("react");

export const StructureEditContext = createContext();
